import { ProductRespDTO, SkuRespDTO } from "@/service/goods";
import { floatingRate, allIncludeExchangeRate } from "@/util/useYan";
import { t } from "@/plugins/i18n";
import {
  AdditionRespDTO,
  CalcParamVO,
  CustomerAdditionRespDTO,
  CustomerAdditionTemplateItemInfoRespDTO,
  ProductParamVO,
} from "@/service/settlement";
import { isJA } from "@/store";

export interface extSkuRespDTO extends SkuRespDTO {
  categoryCode?: string;
  adaptType?: string;
  adaptTypeModifyFlag?: boolean;
  isLive?: boolean;
  additionIdList?: number[];
  additionList?: CustomerAdditionTemplateItemInfoRespDTO[];
}

interface extProductParamVO extends ProductParamVO {
  additionList?: AdditionRespDTO[];
}
export interface extCalcParamVO extends CalcParamVO {
  productParam?: extProductParamVO[];
  additionList?: CustomerAdditionRespDTO[];
}
export interface extProductRespDTO extends ProductRespDTO {
  ladder?: any;
  showLladder?: boolean;
  consignRangePrice?: any;
  finalProductSellPrice?: any;
  supplierSpu?: string;
  adaptTypeModifyFlag?: boolean;
  /** 季节属性 */
  seasonTag?: string;
  isfavo?: number;
  finalProductSellPriceJpy?: any;
  /** 是否一价全包商品 */
  isAllCal?: boolean;
  /** 商品后台分类 */
  categoryCode?: string;
  skuList?: extSkuRespDTO[];
}

export const getUnderLineProductPrice = (data: extProductRespDTO) => {
  // 阶梯价
  const productPriceLadderList = data?.productPriceLadderList || [];
  const priceName =
    data.switchAllIncludePriceJp === 1 && isJA()
      ? "allIncludePriceJp"
      : "price";
  const skuPriceName =
    data.switchAllIncludePriceJp === 1 && isJA()
      ? "allIncludePriceJp"
      : "productSellPrice";
  const rateVal =
    data.switchAllIncludePriceJp === 1 && isJA()
      ? allIncludeExchangeRate.value
      : floatingRate.value;
  console.log(rateVal, "rateVal");

  // 阶梯价最高最低价
  let min = 0;
  let max = 0;
  productPriceLadderList.forEach((item: any) => {
    min = min ? Math.min(item[priceName], min) : item[priceName];
    max = max ? Math.max(item[priceName], max) : item[priceName];
  });
  // sku最大值最小值
  let skuMin = 0;
  let skuMax = 0;
  data?.skuList?.forEach((item: any) => {
    skuMin = skuMin ? Math.min(item[skuPriceName], skuMin) : item[skuPriceName];
    skuMax = skuMax ? Math.max(item[skuPriceName], skuMax) : item[skuPriceName];
  });

  // 线下商品
  if (data.channel === 5) {
    if (productPriceLadderList.length > 0) {
      // 线下商品维护阶梯价
      // 价格：取阶梯价格区间
      data.finalProductSellPrice = min === max ? min : `${min}-${max}`;
      data.finalProductSellPriceJpy =
        min === max
          ? Math.round(min * rateVal)
          : `${Math.round(min * rateVal)}-${Math.round(max * rateVal)}`;
      // sku单价：默认取阶梯价的最高价格，当加购数量达到下一个阶梯，则更新sku单价
      data?.skuList?.forEach((i: any) => {
        i.productSellPrice = max;
      });
      // 商品价格：取sku单价最大值
      data.productSellPrice = max;
    } else {
      // 未维护阶梯价
      // 取该spu下所有sku单价的区间展示
      data.finalProductSellPrice =
        skuMin === skuMax ? skuMin : `${skuMin}-${skuMax}`;
      data.finalProductSellPriceJpy =
        skuMin === skuMax
          ? Math.round(skuMin * rateVal)
          : `${Math.round(skuMin * rateVal)}-${Math.round(skuMax * rateVal)}`;
      // 商品金额：取sku单价最小值
      data.productSellPrice = skuMin;
      if (data.switchAllIncludePriceJp === 1 && isJA()) {
        data.skuList?.forEach((i) => {
          i.productSellPrice = i.allIncludePriceJp;
        });
      }
    }
  }
  return data;
};
